import React, { useState } from 'react';
import { STAFF_SECTIONS } from '../utils/staffAccess';
import { updateStaffSections } from '../services/membershipService';
import './StaffSectionAccess.css';

export default function StaffSectionAccess({ membership, onSaved }) {
  const [sections, setSections] = useState(membership.staffSections || []);
  const [busy, setBusy] = useState(false);
  const [error, setError] = useState('');
  const [saved, setSaved] = useState(false);
  const save = async () => {
    setBusy(true);
    setError('');
    setSaved(false);
    try {
      const result = await updateStaffSections(membership._id, sections);
      onSaved(result.data);
      setSaved(true);
    } catch (err) {
      setError(err.response?.data?.message || 'Could not save staff access. Your selections have been kept.');
    } finally {
      setBusy(false);
    }
  };
  return <div className="staff-section-access">
    <fieldset disabled={busy}>
      <legend>Assigned work sections</legend>
      <p className="fieldset-hint">Select the work this person manages. Combine sections as needed.
        Unchecked sections grant no staff tools; their own contributor access stays unchanged.
        Disabled community modules remain unavailable.</p>
      <div className="staff-section-access__options">
      {STAFF_SECTIONS.map(({ key, label, description }) => <label key={key} className="staff-section-access__option">
        <input type="checkbox" checked={sections.includes(key)} onChange={(event) => {
          setSaved(false);
          setSections(event.target.checked ? [...sections, key] : sections.filter((section) => section !== key));
        }} aria-label={label} />
        <span><strong>{label}</strong><small>{description}</small></span>
      </label>)}
      </div>
      <button type="button" onClick={save}>{busy ? 'Saving...' : 'Save staff access'}</button>
    </fieldset>
    {error && <p role="alert">{error}</p>}
    {saved && <p role="status">Staff access saved.</p>}
  </div>;
}
